<template>
    <v-layout row justify-center v-if="visible">
        <v-card elevation="0" style="max-width: 1000px;">
            <v-card-title>
                <h3>{{ $t("circularSaw") }}</h3>
            </v-card-title>
            <v-card-text>
                 <v-layout wrap dense>
                    <v-flex xs12 sm2>
                        <v-layout wrap dense>
                            <v-flex xs12 sm10>
                                <v-text-field
                                    :label="$t('maxSawsAmount')"
                                    :hint="$t('maxSawsAmount')"
                                    :rules="[rules.required, rules.maxAmount]"
                                    @change="changeHandler"
                                    v-model="maxAmount.val"
                                    ref="maxSaws"
                                    required
                                    dense
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs12 sm10>
                                <v-text-field
                                    :label="$t('kerf')"
                                    :hint="`${$t('kerf')}, ${$t('mm')}`"
                                    :suffix="$t('mm')"
                                    :rules="[rules.required, rules.kerf]"
                                    @change="changeHandler"
                                    v-model="kerf.val"
                                    ref="kerf"
                                    required
                                    dense
                                ></v-text-field>
                            </v-flex>
                            <!-- <v-flex xs12 sm10>
                                <v-text-field
                                    :label="$t('kerfExt')"
                                    :hint="`${$t('kerfExt')}, ${$t('mm')}`"
                                    :suffix="$t('mm')"
                                    :rules="[rules.required, rules.kerfExt]"
                                    @change="changeHandler"
                                    v-model="kerfExt.val"
                                    ref="kerfExt"
                                    required
                                    hide-details
                                ></v-text-field>
                            </v-flex> -->
                        </v-layout>
                    </v-flex>

                    <v-flex xs12 sm2>
                        <v-checkbox
                            v-model="halfCantEnabled"
                            :label="$t('halfCant')"
                            hide-details
                            dense
                        ></v-checkbox>
                        <v-text-field
                            :disabled="!halfCantEnabled"
                            :label="$t('centralKerf')"
                            :suffix="$t('mm')"
                            :rules="[rules.required, rules.halfCant]"
                            @change="changeHandler"
                            v-model="halfCant.val"
                            class="mt-3"
                            dense
                        ></v-text-field>

                    </v-flex>

                    <v-divider vertical class="mx-3"></v-divider>

                    <v-flex xs12 sm4>
                        <v-layout wrap dense>
                            <v-flex xs12>
                                <v-checkbox
                                    v-model="similarSizeBoards"
                                    :label="$t('sameSizeSides')"
                                    hide-details
                                    dense
                                ></v-checkbox>
                                <v-checkbox
                                    v-model="useEdgeTrimmer"
                                    :label="$t('edgeTrimmerUsed')"
                                    hide-details
                                    dense
                                ></v-checkbox>
                                <v-layout wrap dense class="mt-2">
                                    <v-flex xs6 pr-1>
                                        <v-text-field
                                            :label="$t('maxSawsAmount')"
                                            :hint="$t('maxSawsAmount')"
                                            :rules="[rules.required, rules.maxAmount]"
                                            v-model="edgeTrimmerMaxAmount.val"
                                            @change="changeHandler"
                                            ref="edgeTrimmerMaxAmount"
                                            required
                                            :disabled="!useEdgeTrimmer"
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex xs6>
                                        <v-text-field
                                            :label="$t('kerf')"
                                            :hint="`${$t('kerf')}, ${$t('mm')}`"
                                            :suffix="$t('mm')"
                                            :rules="[rules.required, rules.kerf]"
                                            v-model="edgeTrimmerKerf.val"
                                            @change="changeHandler"
                                            required
                                            ref="edgeTrimmerKerf"
                                            :disabled="!useEdgeTrimmer"
                                        ></v-text-field>
                                    </v-flex>
                                </v-layout>
                            </v-flex>
                        </v-layout>
                    </v-flex>

                    <v-divider vertical class="mx-3"></v-divider>

                    <v-flex xs12 sm3>
                        <v-layout wrap dense>
                            <v-checkbox
                                v-model="useCleanSaws"
                                @change="changeHandler"
                                :label="$t('cleanSawsUsed')"
                                hide-details
                                dense
                            ></v-checkbox>
                            <v-flex xs12 sm6 class="mt-2">
                                <v-text-field
                                    :label="$t('cleanKerf')"
                                    :hint="`${$t('kerf')}, ${$t('mm')}`"
                                    :suffix="$t('mm')"
                                    :rules="[rules.required, rules.cleanKerf]"
                                    @change="changeHandler"
                                    v-model="cleanKerf.val"
                                    required
                                    dense
                                    :disabled="!useCleanSaws"
                                    ref="cleanKerf"
                                ></v-text-field>
                            </v-flex>
                        </v-layout>
                    </v-flex>

                 </v-layout>
            </v-card-text>
        </v-card>
    </v-layout>
</template>

<script>
    export default {
        name: "CircularSawSettings",

        data () {
            return {
                changed:         false,
                checkingInput:   false,
                disableWatch:    false,
                halfCantEnabled: true,
                halfCant:        { val: 0, min: 0, max: 0 },
                maxAmount:       { val: 0, min: 0, max: 0 },
                kerf:            { val: 0, min: 0, max: 0 },
                kerfExt:         { val: 0, min: 0, max: 0 },
                edgeTrimmerMaxAmount:     { val: 0, min: 0, max: 0 },
                edgeTrimmerKerf:          { val: 0, min: 0, max: 0 },
                thicknessByKerf: false,
                useEdgeTrimmer: true,
                similarSizeBoards: false,
                useCleanSaws: false,
                cleanKerf: { val: 0, min: 0, max: 0 },
                rules: {
                    required:  value => !!value || this.$t("requiredField"),
                    isNumber:  value => !isNaN(value) || this.$t("incorrectValue"),
                    halfCant:  value => (value >= this.halfCant.min && value <= this.halfCant.max) || this.$t("incorrectValue"),
                    maxAmount: value => (value >= this.maxAmount.min && value <= this.maxAmount.max) || this.$t("incorrectValue"),
                    kerf:      value => (value >= this.kerf.min && value <= this.kerf.max) || this.$t("incorrectValue"),
                    kerfExt:   value => (value >= this.kerfExt.min && value <= this.kerfExt.max) || this.$t("incorrectValue"),
                    edgeTrimmerMaxAmount: value => (value >= this.edgeTrimmerMaxAmount.min && value <= this.edgeTrimmerMaxAmount.max) || this.$t("incorrectValue"),
                    edgeTrimmerKerf:      value => (value >= this.edgeTrimmerKerf.min && value <= this.edgeTrimmerKerf.max) || this.$t("incorrectValue"),
                    cleanKerf:      value => (value >= this.cleanKerf.min && value <= this.cleanKerf.max) || this.$t("incorrectValue")
                },
                visible: false
            }
        },

        watch: {
            halfCant:        function () { this.changed = !this.disableWatch ? true : this.changed; },
            halfCantEnabled: function () { this.changed = !this.disableWatch ? true : this.changed; },
            thicknessByKerf: function () { this.changed = !this.disableWatch ? true : this.changed; },
            similarSizeBoards:  function () { this.changed = !this.disableWatch ? true : this.changed; },
            useEdgeTrimmer:  function () { this.changed = !this.disableWatch ? true : this.changed; },
            useCleanSaws: function () { this.changed = !this.disableWatch ? true : this.changed; },
            visible:         function (val) { this.changed = val ? false : this.changed; },
        },

        methods: {
            /**
             *  Отслеживание изменений
             */
            changeHandler () {
                if (!this.disableWatch) { this.changed = true; }
            }
        }
    }
</script>
